var map = {
	"./en.svg": 89981,
	"./es.svg": 39706,
	"./fr.svg": 99779,
	"./ja.svg": 60613,
	"./ptbr.svg": 65208,
	"./zh.svg": 66573,
	"assets/lang/en.svg": 89981,
	"assets/lang/es.svg": 39706,
	"assets/lang/fr.svg": 99779,
	"assets/lang/ja.svg": 60613,
	"assets/lang/ptbr.svg": 65208,
	"assets/lang/zh.svg": 66573
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34314;